<template>
    <div class="actBanner" v-if="columnList.length">
        <div class="ul">
            <div class="li" v-for="(item, index) in columnList" :key='item.id + index' v-track:click :track-params="JSON.stringify({event: 102, tabNumber: index + 1, tabName: item.name})">
                <div class="img" @click="goLink(item.link, index, item.name)">
                    <img :src="item.pictureUrl" alt="">
                </div>
                <div class="title" :class="{'fs24': item.name.length > 4}" v-text="item.name.slice(0, 6)"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'actBanner',
    props: {
        columnList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        goLink (link, index, name) {
            this.$emit('goLink', { link, index, name })
        }
    }
}
</script>
<style lang="scss" scoped>
.actBanner {
    background: #ffffff;
    .ul {
        display: flex;
        flex-flow: wrap;
        .li {
            flex: 0 0 20%;
            margin-bottom: 24px;
            .img {
                width: 80px;
                height: 80px;
                margin: 0 auto;
                border-radius: 50%;
                img {
                    border-radius: 50%;
                    width: 100%;
                    height: 100%;
                }
            }
            .title {
                font-size: 24px;
                line-height: 36px;
                font-weight: 400;
                color: #333333;
                text-align: center;
                margin-top: 12px;
                white-space: normal;
                word-break: break-all;
                &.fs24 {
                    font-size: 24px;
                }
            }
        }
    }
}
</style>
